<template>
	<el-tabs>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-document-remove"></i>页面属性</span>
			<div style="padding:10px 20px;">
				<el-input v-model="value.biaoti" placeholder="请输入标题"> <template slot="prepend">标题</template></el-input>
			</div>
			<div style="padding:10px 20px;">
				<span class="zhuantai" style="color: #999999; margin-right: 10px;">类型:</span>
				<el-select  placeholder="请选择类型" size="small" v-model="value.leixing">
				      <el-option label="首页" value="index"></el-option>
			    </el-select>			
			</div>
			<div style="padding:10px 20px;">				
				<span class="zhuantai" style="color: #999999; margin-right: 10px;">状态:</span>
				<el-radio-group v-model="value.zhuangtai">
					<el-radio  label="1">开启</el-radio>
					<el-radio  label="0">关闭</el-radio>
				</el-radio-group>
			</div>
			
			<div style="padding:10px 20px;">
				<span class="zhuantai" style="color: #999999; margin-right: 10px;">默认:</span>
				 <el-checkbox v-model="value.moren" true-label="1" false-label="0"></el-checkbox>		
			</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		data() {
			return {
				radio: 1
			}
		},
		name: 'anniu_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},


	}
</script>
<link rel="stylesheet" href="Yangshi.css">
